export const ADD_LOADING = "ADD_LOADING";
export const ADD_PLAN = "ADD_PLAN";
export const PLAN_FAILURE = "PLAN_FAILURE";
export const PLAN_SUCCESS = "PLAN_SUCCESS";
export const GET_PLAN = "GET_PLAN";
